'use client';

import { Component, type ReactNode } from 'react';
import { ErrorState } from '@org/design-system';

interface ComponentErrorBoundaryProps {
  children: ReactNode;
  errorTitle?: string;
  errorDescription?: string;
}

interface ComponentErrorBoundaryState {
  hasError: boolean;
}

export class ComponentErrorBoundary extends Component<
  ComponentErrorBoundaryProps,
  ComponentErrorBoundaryState
> {
  constructor(props: ComponentErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ComponentErrorBoundaryState {
    return { hasError: true };
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorState
          title={this.props.errorTitle || 'Something went wrong'}
          description={this.props.errorDescription || 'This page failed to render. Please try again.'}
          onRetry={this.handleRetry}
        />
      );
    }

    return this.props.children;
  }
}
